module.exports = __webpack_public_path__ + "static/media/serviceProviderimg4.2fdb31a7.png";